// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3hnu0","addWidgetButton":"Header_addWidgetButton__3Ql0U","dashboardTabs":"Header_dashboardTabs__Sw8zl","active":"Header_active__3nKN5"};